/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = WaitingParts
 *
 * 2 = WaitingAuthority
 *
 * 3 = TechnicalCase
 */
export enum ClockingPauseType {
  WaitingParts = 1,
  WaitingAuthority = 2,
  TechnicalCase = 3,
}
